module.exports = __webpack_public_path__ + "img/micky.5e0c722d.png";